<template>
  <div>
    <!-- kepala -->
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100% !important;
        top: 0px;
        right: 0px;
        left: 0px;
        z-index: 1;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div style="width: 100%" class="col-12 mt-4">
         <!-- <p @click="GoToHome()" class="float-right">Go to Home</p> -->
        <!-- <div class="col-12">
          <CCard class="col-12 coin-right">
            <CRow>
              <img src="../assets/img/coin.png" width="40px" height="40px" style="margin-left: -20px; margin-top: -8px; margin-bottom: -15px"/>
              <p style="font-size: 17px; margin-top: 0px;
              margin-bottom: 0px;"><strong>150</strong></p>
              <div class="text-right">
              <img src="../assets/img/iconAdd.png" class="text-right" width="35px" height="35px" style="margin-right: -45px; margin-top: -10px; margin-bottom: -10px;" @click="EShop()"/>
              </div>
            </CRow>
          </CCard>
        </div> -->
          <br />
        <div class="image" align="center">
          <img src="../assets/img/Logo.png" width="50 px" height="50 px" />
        </div>
        <h3 class="text-center text-white m-0">Hi, {{ StudentProfile.StudentName}}</h3>
        <p class="text-center text-white m-1">Welcome to pickiddo Quiz!</p>
       
        <br />
        <CCol sm="12">
          <span class="mt-5 mb-5"> </span>
          <br /><br />
        </CCol>
      </div>
    </div>

    <!-- Buttons card -->
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 90px;
        z-index: 1;
      "
    >
      <CRow class="justify-content-center">
        <CCol
          style="display: flex; align-items: center; justify-content: center"
          align="center"
        >
          <CCol sm="12" lg="12" class="custom-margin"><br />
            <CCard class="custom-cardTitle p-1 box-shadow">
              <CCol
                sm="12"
                lg="12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToDashBoard()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                  <CCol>
                    <CIcon
                      style="color: darkcyan"
                      name="cil-list-rich"
                      width="25px"
                      title="Daily Quiz"
                    />
                    <!-- <img src="../assets/img/iconquiz.png" width="30px" /> -->
                    <div class="custom-gradient" title="Daily Quiz">Quiz</div>
                  </CCol>
                </CCol>

                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToStatistic()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                  <CCol>
                    <CIcon
                      style="color: darkcyan"
                      name="cil-clipboard"
                      width="25px"
                    />
                    <!-- <img src="../assets/img/icontest.png" width="30px" /> -->
                    <div class="custom-gradient">Compete</div>
                  </CCol>
                </CCol>

                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToScore()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                  <CCol>
                    <CIcon
                      style="color: darkcyan"
                      name="cil-chart"
                      width="25px"
                      title="Score Card"
                    />
                    <!-- <img src="../assets/img/iconscorerate.png" width="30px" /> -->
                    <div class="custom-gradient" title="Score Card">Score</div>
                  </CCol>
                </CCol>

                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToAccount()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                  <CCol>
                    <CIcon
                      style="color: darkcyan"
                      name="cil-user"
                      width="25px"
                      title="My Account"
                    />
                    <!-- <img src="../assets/img/usernobg.png" width="30px" /> -->
                    <div class="custom-gradient" title="My Account">
                      Account
                    </div>
                  </CCol>
                </CCol>
                
              </CCol>
            </CCard>
          </CCol>
        </CCol>
      </CRow>
    </div>
    <br /><br />
    <br /><br />

    

  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import backgroundBanner from "../assets/img/bgApps.jpg";
// Tell Vue to install the plugin.
export default {
  name: "Login",
  components: {},
  data() {
    return {
      backgroundBanner,
      StudentProfile: {},
      PurchaseCoinModal: false,
    };
  },
  async mounted() {
    this.GetStudentProfile();
  },
  computed: {},
  methods: {
    async GetStudentProfile() {
      this.$API
        .get(
          this.$StudentProfile +
            "?studentId=" +
            this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.StudentProfile = response.data;
            console.log("StudentProfile", this.StudentProfile);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GoToDashBoard() {
      this.$router.push(
        "/QuizStudentDashboard?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    GoToStatistic() {
      this.$router.push(
        "/QuizStudentExam?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    GoToScore() {
      this.$router.push(
        "/QuizStudentOverview?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    GoToAccount() {
      this.$router.push(
        "/QuizStudentProfile?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    EShop() {
      this.$router.push(
        "/QuizStudentSubscription?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
      GoToHome() {
      this.$router.push("/student/Mainpage?userId=" + this.$route.query.userId);
    },
  },
};
</script>

<style>
.coin-right {
  border-radius: 30px;
  border-color: #ffff00;
  border-width: 3px;
  color: #000000;          
  width: 20%;
  position: absolute;
  top: 50%;
  left: 80%;
  transform: translate(-30%, -10%);
  background: rgb(255,255,255);
  background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,220,160,0.8015581232492998) 80%);
}
.coin_card{
  background: rgb(179,155,255);
background: linear-gradient(180deg, rgba(179,155,255,0.5914740896358543) 10%, rgba(255,220,160,0.8015581232492998) 60%);
}

.coin_card2{
 background: rgb(255,220,160);
background: linear-gradient(180deg, rgba(255,220,160,0.8015581232492998) 40%, rgba(179,155,255,0.6194852941176471) 80%);
}
</style>